import { render } from "./Custom.vue?vue&type=template&id=e85f1efe&scoped=true&ts=true"
import script from "./Custom.vue?vue&type=script&lang=ts"
export * from "./Custom.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=e85f1efe&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85f1efe"]])

export default __exports__